<template>
	<section>
		<div class="w-full max-w-screen-md mx-auto px-6">

			<h2 class="text-2xl font-bold text-center mb-12">
				{{ __('home::index.faq') }}
			</h2>

			<div
				v-for="(item, index) in items"
				:key="index"
				class="py-4 border-b border-gray-200"
			>
				<button type="button" class="w-full flex justify-between items-center text-lg font-bold cursor-pointer focus:ring-0" @click="item.active = ! item.active">
					<h3>{{ item.title }}</h3>
					<ChevronDownIcon class="w-8 h-8" :class="{ 'rotate-180': item.active }" />
				</button>
				<p v-show="item.active" class="block py-4 whitespace-pre-line">
					{{ item.body }}
				</p>
			</div>

		</div>
	</section>
</template>

<script>
import { ChevronDownIcon } from '@heroicons/vue/solid';

export default {
	components: {
		ChevronDownIcon,
	},
	data() {
		return {
			items: [
				{
					title: this.__('home::faq.item_1_title'),
					body: this.__('home::faq.item_1_body'),
					active: false,
				},
				{
					title: this.__('home::faq.item_2_title'),
					body: this.__('home::faq.item_2_body'),
					active: false,
				},
				{
					title: this.__('home::faq.item_3_title'),
					body: this.__('home::faq.item_3_body'),
					active: false,
				},
			],
		};
	},
}
</script>